import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { sendMissingEmail } from "@/Services/TherapyApi/Clients";

import usePatientsStore from "@/Modules/Patients/Store";
import useAppStore from "@/Modules/App/Store";

async function sendMissingEmailAH(uuid: string): Promise<boolean> {
  const appStore = useAppStore();
  const patientsStore = usePatientsStore();

  try {
    await sendMissingEmail(uuid);

    if (patientsStore.selected) {
      patientsStore.selected.lastMissingEmailNotification = new Date().getTime() / 1000;
    }

    appStore.showSnackbar({
      message: "patients.connection_notice.success",
      type: NotificationType.SUCCESS,
    });

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      message: "patients.connection_notice.error",
      type: NotificationType.ERROR,
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default sendMissingEmailAH;
